import { applyMiddleware, createStore, compose, combineReducers } from 'redux'
import thunk from 'redux-thunk'
import promise from 'redux-promise'
import createLogger from 'redux-logger'
import { i18nState } from 'redux-i18n'
import { userReducer } from '../reducers/userReducer'
import { accountsReducer } from '../reducers/accountsReducer'
import { rolesReducer } from '../reducers/rolesReducer'
import { applicationsReducer } from '../reducers/applicationsReducer'
import types from '../types/types'

const composeEnhancers = (typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose;

const logger = createLogger({
  collapsed: true
});

const appReducer = combineReducers({
  i18nState,
  user: userReducer,
  accounts: accountsReducer,
  roles: rolesReducer,
  applications: applicationsReducer,
});

export const reducers = (state, action) => {
  if (action.type === types.restart_redux_on_logout) {
    debugger
    return appReducer(undefined, action);
  }

  return appReducer(state, action);
}

export const store = createStore(
    reducers,
    composeEnhancers(
        applyMiddleware(thunk, promise, logger)
    )
)